import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getInitiativeSummary } from '@api';
import { put } from 'redux-saga/effects';
import { selectCurrentInitiativeId } from '../selectors';
import { updateInitiativeReferences } from '../_idMap/actions';

export const coreInitiativesSummaryGetAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				updateInitiativeReferences([
					{
						initiativeId: request.initiativeId,
						ownerIds: response.ownerIds,
						scopeCounts: response.scopeCounts,
						stakeholders: response.stakeholders
					}
				])
		]
	},
	name: 'CoreInitiativesSummary',
	receive: true,
	request: true,
	requestHandler: getInitiativeSummary
});

export function* refreshCurrentInitiativeSummarySaga() {
	const initiativeId: number | undefined = yield selectCurrentInitiativeId();

	if (initiativeId) {
		yield put(
			coreInitiativesSummaryGetAsyncSlice.asyncActionCreators.requestGetCoreInitiativesSummary({
				initiativeId
			})
		);
	}
}
